import {FormProvider, SubmitHandler, useForm} from "react-hook-form";
import {useNavigate} from "react-router-dom";
import SubTitle from "../../components/SubTitle";
import {useCreateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem} from "../../models/clientModels/interfaces/Response";
import * as yup from "yup";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import * as statisticsCategoryApi from "../../api/statisticsApi/statisticsCategoryApi";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import MWProgress from "../../components/MWProgress";
import {WOStatisticsCategory} from "../../models/serverModels/workOrder/WOStatisticsCategory";
import {initializeStatisticsItem} from "../../models/serverModels/workOrder/WOStatisticsItem";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import StatisticsCategoryForm from "./StatisticsCategoryForm";
import {yupResolver} from "@hookform/resolvers/yup";

const statisticsCategorySchema = yup.object({
  categoryName: yup.string().required("카테고리명을 입력해주세요"),
  displayOrder: yup.number(),
});

const CreateStatisticsCategory = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<WOStatisticsCategory>,
    Params.Create<WOStatisticsCategory>
  >({
    api: statisticsCategoryApi.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate("/Statistics");
        queryClient.invalidateQueries("statisticsCategoryList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });
  const methods = useForm<WOStatisticsCategory>({
    defaultValues: initializeStatisticsItem,
    resolver: yupResolver(statisticsCategorySchema),
  });
  const onSubmit: SubmitHandler<WOStatisticsCategory> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializeStatisticsItem, ...data},
    });
  };
  return (
    <FormProvider {...methods}>
      <SubTitle subTitle="범례내용 분류 편집" />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <StatisticsCategoryForm />
          <ConfirmButtonGroup link="/Statistics" cancelText="취소" confirmText="추가" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreateStatisticsCategory;
